<template>
  <v-menu
      ref="menu"
      :value="menu"
      @input="setMenu(!menu)"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
          outlined
          :color="$store.state.achievement.side_color"
          :value="date_end"
          label="Дата"
          readonly
          class="rounded-xl"
          v-bind="attrs"
          v-on="on"
          :rules="achievementDateRules"
          dense
      >
        <template #append>
          <v-icon
              @click="setMenu(!menu)"
              :color="menu ? $store.state.achievement.side_color : 'black'"
          >
            fa fa-calendar
        </v-icon>
        </template>
      </v-text-field>
    </template>
    <v-date-picker
        v-model="date_end"
        :color="$store.state.achievement.side_color"
        :header-color="$store.state.achievement.side_color"
        locale="ru"
        scrollable
        elevation="15"
        :max="(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)"
        min="2016-01-01"
    >
      <v-spacer></v-spacer>
      <v-btn
          text
          color="primary"
          @click="setMenu(false)"
      >
        Отмена
      </v-btn>
      <v-btn
          text
          color="primary"
          @click="setMenu(false)"
      >
        OK
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import AchievementFormStore from "../../../../stores/application/portfolio/achievement_form_store";
import {createHelpers} from "vuex-map-fields";

const {mapFields} = createHelpers({
  getterType: 'achievement/getPayloadAchievement',
  mutationType: 'achievement/updatePayloadAchievement',
});

export default {
  name: "DatePicker",
  data() {
    return {
      achievementDateRules: [
        v=> !!v || 'Выберите дату.',
      ],
    }
  },

  computed: {
    ...mapState({
      menu: state => state.achievement.date_picker_menu,
    }),

    ...mapFields([
      'date_end',
    ]),

  },

  methods: {
    ...mapMutations({
      setMenu: 'achievement/setDateDatepicker',
      setAchievementData: 'achievement_form/setAchievementData',
    }),
  },
}
</script>

<style scoped>

</style>